// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {UserFormModuleLayout} from 'app_components/modules/admin/user/userForm'
// @end

// @import events
// @end

// @import utils
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
import { I18nUtil } from 'app_utils/i18n'
// @end

// @import services
import UserService from 'app_services/user/userService'
import ReactSelectService from 'app_services/components/reactSelectService'
import { UserFormInputs } from 'app_types/admin/user/userTypes'
// @end

// @import types
// @end

// @ADD Component types
interface IUserFormModuleProps {
  onHandleSubmit?: (data: any) => void
  editData?: any
  viewer: boolean
  role?: string | undefined
  show_inputs?: UserFormInputs[]
  editabled_inputs?: UserFormInputs[]
}
interface IUserFormModuleState {}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class UserFormModule extends Component<IUserFormModuleProps, IUserFormModuleState> {

  private reactSelectService: ReactSelectService
  private userService: UserService
  private screenNotifications: ScreenNotificationsUtil
  private i18nUtil: I18nUtil

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IUserFormModuleProps) {
    super(props)
    this.state = {}

    this.reactSelectService = new ReactSelectService()
    this.userService = new UserService()
    this.screenNotifications = new ScreenNotificationsUtil()
    this.i18nUtil = new I18nUtil()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {}

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods
  onSubmit = async (data: any) => {

    const isUpdate: boolean = (this.props.editData && this.props.editData._id)
    const isCompanyUser: boolean = data.roles?.find((r: any) => r.label === 'Contacto de Empresa') ? true : false

    if (data.password === '') {
      delete data.password
      delete data.confirm_password
    }

    if (data.roles) data.roles = this.reactSelectService.formatReactSelectResponse(data.roles)

    if (isCompanyUser) {
      data.sendEmail = true
    }


    const userResponse = await this.userService.insertOrUpdate(
      data,
      isUpdate ? `update/${this.props.editData._id}` : 'create'
    )

    if (userResponse) {
      let screen_notification_label = 'components.screen_notifications.add'
      if (this.props.editData && this.props.editData._id) {
        screen_notification_label = 'components.screen_notifications.update'
      }

      this.screenNotifications.fireToast(
        {
          message: `${this.i18nUtil.getTranslate(screen_notification_label)}`,
        },
        {
          position: 'bottom-right',
        }
      )

      if (this.props.onHandleSubmit) {
        this.props.onHandleSubmit(userResponse)
      }
    }

    this.setState({ status: null })
  }

  render() {
    return(
      <UserFormModuleLayout
        {...this.props}
        onHandleSubmit={this.onSubmit}
        viewer={this.props.viewer}
        role={this.props.role}
        show_inputs={this.props.show_inputs}
        editabled_inputs={this.props.editabled_inputs}
      />
    )
  }
}

export default connect(mapStatesToProps)(UserFormModule)
